module.exports = __webpack_public_path__ + "img/blog6-logo-1.f28826cb.webp";